import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
/**
  Componente que muestra un ícono de verificación (check) cuando un campo de formulario es válido.
  Este componente es útil para proporcionar retroalimentación visual al usuario cuando un campo
  de formulario cumple con las validaciones requeridas. También permite personalizar el ícono
  y manejar casos especiales como campos de fecha o validaciones específicas de TIMATIC.
**/
@Component({
    selector: 'app-icon-form-correct',
    templateUrl: './icon-form-correct.component.html',
    styleUrls: ['./icon-form-correct.component.scss'],
    standalone: false
})
export class IconFormCorrectComponent implements OnInit {

/**
    Clase CSS personalizada que se aplicará al contenedor del ícono.
    @type {string}
  **/
    @Input() className = '';

    /**
      Campo de formulario asociado al ícono de verificación.
      @type {any}
    **/
    @Input() fieldInput: any;
  
    /**
      Identificador único para el campo de día en un formulario de fecha.
      @type {string}
    **/
    @Input() idD = '';
  
    /**
      Identificador único para el campo de mes en un formulario de fecha.
      @type {string}
    **/
    @Input() idM = '';
  
    /**
      Identificador único para el campo de año en un formulario de fecha.
      @type {string}
    **/
    @Input() idY = '';
  
    /**
      Ruta de la imagen del ícono de verificación.
      @type {string}
      @default '../../../assets/images/checkSimple.svg'
    **/
    @Input() image = '../../../assets/images/checkSimple.svg';
  
    /**
      Formulario al que pertenece el campo.
      @type {FormGroup}
    **/
    @Input() nameForm: FormGroup;
  
    /**
      Indica si el campo es de tipo fecha.
      @type {boolean}
      @default false
    **/
    @Input() typeDate = false;
  
    /**
      Indica si el campo está relacionado con la validación de residencia TIMATIC.
      @type {boolean}
      @default false
    **/
    @Input() typeTimaticResidence = false;

  constructor() { }

  ngOnInit(): void {
  }

}
